/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { updatePageDetails, changePage, displayMessage } from '@insticator/insticator-ui';
import { updateSelectedCountries, updateSelectedSites, updateSelectedDevices, updateDateRange, updateSelectedRevenueType, getAllCountries, clearHomeControls } from 'state/actions/homeState/home_analytics_status';
import { getTotalQuestionsAnswered, getTotalTopQuestionsAnswered, getTotalAverageInView, getTotalUniqueEngagedUsers, getAllRevenueMetricsTotal, getTopStories, getTopStoryClicks } from 'state/actions/homeState/home_analytics_data';
import { viewAnalytics } from 'state/actions/embedsState/embeds_status';
// component
import OverviewPage from 'pages/dashboard/analytics/overview/overview';



/* ========== ~~~~~~~~~~ ANALYTICS OVERVIEW : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ homeState, accountData, sessionStatus, embedsState }) => {
    const { homeAnalyticsData, homeAnalyticsStatus } = homeState;

    return {
        adMetricsData: homeAnalyticsData.adMetricsData,

        questionsAnswered: homeAnalyticsData.contentPerformanceData.questionsAnswered,
        fetchingQuestions: homeAnalyticsData.contentPerformanceData.fetchingQuestions,

        topQuestionsAnswered: homeAnalyticsData.contentPerformanceData.topQuestionsAnswered,
        fetchingTopQuestion: homeAnalyticsData.contentPerformanceData.fetchingTopQuestion,

        averageInView: homeAnalyticsData.embedEngagementData.averageInView,
        fetchingAverageInView: homeAnalyticsData.embedEngagementData.fetchingAverageInView,

        uniqueEngagedUsers: homeAnalyticsData.embedEngagementData.uniqueEngagedUsers,
        fetchingUniqueEngagedUsers: homeAnalyticsData.embedEngagementData.fetchingUniqueEngagedUsers,

        totalStoryClicks: homeAnalyticsData.stories.totalStoryClicks,
        fetchingTotalStoryClicks: homeAnalyticsData.stories.fetchingTotalStoryClicks,

        topStories: homeAnalyticsData.stories.topStories,
        fetchingTopStories: homeAnalyticsData.stories.fetchingTopStories,

        revenue: homeAnalyticsData.adMetricsData.revenue,
        cpm: homeAnalyticsData.adMetricsData.cpm,
        impression: homeAnalyticsData.adMetricsData.impression,
        rmsFetching: homeAnalyticsData.adMetricsData.rmsFetching,

        devices: homeAnalyticsStatus.devices,
        selectedDevices: homeAnalyticsStatus.selectedDevices,
        countries: homeAnalyticsStatus.countries,
        countriesReceived: homeAnalyticsStatus.countriesReceived,
        selectedCountries: homeAnalyticsStatus.selectedCountries,
        sites: accountData.sites,
        sitesReceived: accountData.sitesReceived,
        selectedSites: homeAnalyticsStatus.selectedSites,
        selectedRevenueType: homeAnalyticsStatus.selectedRevenueType,
        dateRange: homeAnalyticsStatus.dateRange,
        accountUUID: sessionStatus.accountUUID,
        isDataReceived: embedsState.embedsStatus.isDataReceived,

        adMetricsPermitted: sessionStatus.mocked || sessionStatus.permissions.includes('home.adMetrics'),
        permissionsReceived: sessionStatus.permissionsReceived
    }};

// map actions
const mapDispatchToProps = dispatch => ({
    moveToPage: (location) => {
        dispatch(updatePageDetails(location));
        dispatch(changePage(location))
    },
    displayMessage: message => dispatch(displayMessage(message)),
    updateSelectedCountries: countries => dispatch(updateSelectedCountries(countries)),
    updateSelectedSites: sites => dispatch(updateSelectedSites(sites)),
    // updateSelectedSites: sites => {
    //     //updating detail and overview reducers
    //     dispatch(updateSelectedSites(sites));
    //     dispatch(updataDetailDropDown(sites, 'SITE'))
    // },
    // updateDetailFilters: (sites, range) => {
    //     dispatch(updataDetailDropDown(sites, 'SITE'));
    //     dispatch(updateDetailDateRange(range));
    // },
    updateSelectedDevices: devices => dispatch(updateSelectedDevices(devices)),
    updateSelectedRevenueType: revenueType => dispatch(updateSelectedRevenueType(revenueType)),
    updateDateRange: range => dispatch(updateDateRange(range)),
    // updateDateRange: range => {
    //     //updating detail and overview reducers
    //     dispatch(updateDateRange(range));
    //     dispatch(updateDetailDateRange(range));
    // },
    clearHomeControls: () => dispatch(clearHomeControls()),
    getAllCountries: (accountUUId, paramString) => dispatch(getAllCountries(accountUUId, paramString)),
    getTotalQuestionsAnswered: (paramString) => dispatch(getTotalQuestionsAnswered(paramString)),
    getTotalTopQuestionsAnswered: (paramString) => dispatch(getTotalTopQuestionsAnswered(paramString)),
    getTotalAverageInView: (paramString) => dispatch(getTotalAverageInView(paramString)),
    getTotalUniqueEngagedUsers: (paramString) => dispatch(getTotalUniqueEngagedUsers(paramString)),
    getTopStoryClicks: (paramString) => dispatch(getTopStoryClicks(paramString)),
    getTopStories: (paramString) => dispatch(getTopStories(paramString)),
    getAllRevenueMetricsTotal: (paramString) => dispatch(getAllRevenueMetricsTotal(paramString)),
    viewAnalytics: (embedUUID, accountUUID) => dispatch(viewAnalytics(embedUUID, accountUUID))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(OverviewPage);
